import ReactDOM from "react-dom/client";
import { useLayoutEffect } from "react";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { analyticsService } from "./services/analyticsService";
import { configService } from "./services/configService";
import { posthogService } from "./services/posthogService";
import {
  captureAppBootProfile,
} from "./utils/adminCustomerViewBoot";
import { redirectProductShareFrame } from "./utils/redirectProductShareFrame";
import { captureShareVisitReferrer } from "./utils/shareVisitReferrer";
import { finishHomepageStartup, prepareHomepageStartup } from "./utils/homepageStartup";

function AppStartup() {
  useLayoutEffect(finishHomepageStartup, []);
  return <App />;
}

declare global {
  interface Window {
    plutus: {
      getBuildInfo: () => { env: string; commit: string; built: string };
    };
  }
}

if (!redirectProductShareFrame()) {
  captureShareVisitReferrer();
  const boot = captureAppBootProfile();
  if (boot.status === "valid") {
    analyticsService.initialize();
    posthogService.initialize(boot.profile);
  }

  window.plutus = {
    getBuildInfo: () => configService.getBuildInfo(),
  };

  configService.logBuildInfo();

  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("Root element not found");
  }

  prepareHomepageStartup(rootElement);
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <AppStartup />
  );

  reportWebVitals();
}
